import React, { useEffect, useState } from "react";
import { supabase } from "../../../../supabaseClient";
import { useNavigate } from "react-router-dom";
//*MUI
import {
  Box,
  Divider,
  TableCell,
  Table,
  TableBody,
  TableRow,
  TableHead,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import { getLaunches } from "../../../../Services/FastBooking";

//*files
import cssClasses from "./TokenPaymentStatus.module.css";
import { FetchTokenPaymentData } from "../../../../Services/PaymentStatus";
import TokenPaymentStatusDetailsModal from "../../../../Modals/PaymentStatusDetailsModal/TokenPaymentStatusDetailsModal";
import { groupBy } from "lodash";
import EmptyListIcon from "../../../../Assets/Images/Common/EmptyListLeads.svg";
import CustomAutoComplete from "../../../../Subcomponents/CustomAutoComplete";

import DropDown from "../../../../Subcomponents/DropDown";

function TokenPaymentStatus() {
  const navigate = useNavigate();
  const url = window.location.search;
  let teamIds = JSON.parse(localStorage.getItem("teamIds"));
  const [openMorePaymentStatusDetails, setOpenMorePaymentStatusDetails] =
    useState(false);
  const handleMorePaymentStatusDetailsOpen = () =>
    setOpenMorePaymentStatusDetails(true);
  const handleMorePaymentStatusDetailsClose = () =>
    setOpenMorePaymentStatusDetails(false);
  const [ViewMorePaymentStatusData, setViewMorePaymentStatusData] = useState(
    []
  );
  const [events, setEvents] = useState([]);
  const [eventList, setEventList] = useState([]);

  const [drpDownProjectSelectedVal, setDrpDownProjectSelectedVal] = useState(
    window.location.search.split("?")[1].split("=")[1] !== "null"
      ? decodeURIComponent(window.location.search.split("?")[1].split("=")[1])
      : events[0]?.value
  );
  const [drpDownStatusSelectedVal, setDrpDownStatusSelectedVal] = useState(
    url.includes("launches")
      ? decodeURIComponent(url.split("?")[4].split("=")[1])
      : "All"
  );

  const [userData, setUserData] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [paymentStatusData, setPaymentStatusData] = useState([]);

  const [selectedRowId, setSelectedRowId] = useState(0);

  const [launchesName, setLaunchesName] = useState([]);
  const [launchObj, setLaunchObj] = useState([]);
  const [viewDetailsPopup, setViewDetailsPopup] = useState("");

  const getselectedEventId = (eventNameString) => {
    const eventObj = eventList?.find(
      (el) => el.label === decodeURIComponent(eventNameString)
    );

    return eventObj?.value;
  };
  const getselectedLaunchId = (launchName) => {
    const findlaunchId =
      launchName === "All"
        ? "All"
        : launchObj?.find((el) => el.label === decodeURIComponent(launchName))
            ?.value;

    return findlaunchId;
  };
  async function UsersFromServer(pageNumber, merge, id) {
    presentLoader();
    const selectedEventId = getselectedEventId(id);
    const launchId = getselectedLaunchId(drpDownStatusSelectedVal);

    if (selectedEventId) {
      try {
        const UsersResp = await FetchTokenPaymentData(
          teamIds,
          selectedEventId,
          window.location.search.split("?")[2].split("=")[1],
          window.location.search.split("?")[3].split("=")[1],
          launchId
        );
        const getLaunchesData = async (val) => {

          // const val = url.includes('eventName')?getselectedEventId(url.split("?")[1].split("=")[1]) :getselectedEventId(drpDownProjectSelectedVal)
          
          const query = await supabase
            .from("LaunchSalesRelations")
            .select("*,launchId(*)")
            .in("userId", teamIds)
            .eq("launchId.eventId",val)
            .then((resp) => {
              const launchNullFilter = resp?.data?.filter(el=> el.launchId !== null )
              const launches = launchNullFilter?.map((el) => {
                return el?.launchId?.title
              });
      
              const launchObjArr = launchNullFilter?.map((el) => {
                return { label: el?.launchId?.title, value: el?.launchId?.launchId };
              });
              setLaunchObj(launchObjArr);
              const launchNames = new Set(launches);
              const launchArr = Array.from(launchNames);
      
              setLaunchesName(launchArr);
            })
            .catch((err) => {
              console.log("launch err", err);
            });
      
          return query;
        };
        getLaunchesData(selectedEventId)
        if (UsersResp) {
          const filterDataByStatus = UsersResp.filter(
            (el) =>
              el?.status === "pending" ||
              el?.status === "partial" ||
              el?.status === "active"
          );

          const filterByEventId = filterDataByStatus?.filter(
            (el) =>
              el?.eventId !== null &&
              el?.launchId !== null &&
              el?.leadId.userId !== null &&
              el.leadId !== null
          );

          const groupByLaunchName = groupBy(filterByEventId, `launchId.title`);

          const groupByLaunchesName = Object.keys(groupByLaunchName).map(
            (key) => ({
              launchName: key,
              tokenTypes: groupByLaunchName[key],
            })
          );

          let groupedDataArray = [];

          for (let i = 0; i < groupByLaunchesName.length; i++) {
            const dataa = {
              launchName1: groupByLaunchesName[i]?.tokenTypes,
              "Pre-Select": [],
              "Priority Pass": [],
              "Global Token": [],
            };

            const groupedLaunchName1 = groupBy(dataa.launchName1, (item) => {
              const { isPreselect, isPriorityPass } = item.eventTokenId.tokenId;

              if (isPreselect) {
                return "Pre-Select";
              } else if (isPriorityPass) {
                return "Priority Pass";
              } else {
                return "Global Token";
              }
            });

            const outputObject = {
              launchName: groupByLaunchesName[i]?.launchName,
              TokenTypes: [
                { "Pre-Select": groupedLaunchName1["Pre-Select"] || [] },
                { "Priority Pass": groupedLaunchName1["Priority Pass"] || [] },
                { "Global Token": groupedLaunchName1["Global Token"] || [] },
              ],
            };

            const preSelectArray = outputObject.TokenTypes.find(
              (type) => "Pre-Select" in type
            )["Pre-Select"];

            const groupedPreSelect = groupBy(
              preSelectArray,
              (item) => item.eventTokenId.tokenId.name
            );

            const priorityPassArray = outputObject.TokenTypes.find(
              (type) => "Priority Pass" in type
            )["Priority Pass"];

            const groupedPriorityPass = groupBy(
              priorityPassArray,
              (item) => item.eventTokenId.tokenId.name
            );

            const globalTokenArray = outputObject.TokenTypes.find(
              (type) => "Global Token" in type
            )["Global Token"];

            const groupedGlobalToken = groupBy(
              globalTokenArray,
              (item) => item.eventTokenId.tokenId.name
            );

            const outputObjectForTokenName = {
              launchName: groupByLaunchesName[i]?.launchName,
              TokenTypes: [
                {
                  "Pre-Select": Object.entries(groupedPreSelect)?.map(
                    ([key, value]) => ({
                      [key]: value,
                    })
                  ),
                },
                {
                  "Priority Pass": Object.entries(groupedPriorityPass)?.map(
                    ([key, value]) => ({
                      [key]: value,
                    })
                  ),
                },
                {
                  "Global Token": Object.entries(groupedGlobalToken)?.map(
                    ([key, value]) => ({
                      [key]: value,
                    })
                  ),
                },
              ],
            };

            groupedDataArray.push(outputObjectForTokenName);
          }
          setUserData(groupedDataArray);

          const tableData = groupedDataArray?.map((el, index) => {
            const tokenName =
              el?.TokenTypes[0]["Pre-Select"][0] &&
              Object.keys(el?.TokenTypes[0]["Pre-Select"][0])[0];

            return {
              id: index,
              name: el?.launchName,
              status: "Pre-Select",
              tokenName: tokenName ? tokenName : "-",
              count: tokenName
                ? el?.TokenTypes[0]["Pre-Select"][0][tokenName]?.length
                : "-",
              viewDetails:
                el?.TokenTypes[0]["Pre-Select"]?.length > 0
                  ? el?.TokenTypes[0]["Pre-Select"][0][tokenName]
                  : "-",
            };
          });
          if (merge) {
            setPaymentStatusData((pre) => pre, tableData);
            setPaymentStatus((pre) => pre, tableData);
          } else {
            setPaymentStatusData(tableData);
            setPaymentStatus(tableData);
          }
          dismissLoader();
        }
      } catch (err) {
        console.error("FetchTokenPaymentData", err);
        dismissLoader();
      }
    }
  }
  const getEvents = async () => {
    const query = await supabase
      .from("Events")
      .select("eventId, title")
      .eq("isPublished", true)
      .then((resp) => {
        const eventObj = resp?.data?.map((el) => ({
          label: el?.title,
          value: el?.title,
        }));
        const eventList = resp?.data?.map((el) => ({
          label: el?.title,
          value: el?.eventId,
        }));
        setEventList(eventList);
        setEvents(eventObj);

        dismissLoader();
      })
      .catch((err) => {
        console.log(err);
        dismissLoader();
      });
    return query;
  };

  useEffect(() => {
    presentLoader();
        UsersFromServer(0, false, drpDownProjectSelectedVal);

        navigate(
          window.location.pathname +
            `?eventName=${url.split("?")[1].split("=")[1]}?startDate=${
              url.split("?")[2].split("=")[1] !== null
                ? url.split("?")[2].split("=")[1]
                : 0
            }?endDate=${
              url.split("?")[3].split("=")[1] !== null
                ? url.split("?")[3].split("=")[1]
                : 0
            }?launches=${drpDownStatusSelectedVal}`
        );

        getEvents();
  }, []);

  useEffect(() => {
    if (drpDownProjectSelectedVal) {
      UsersFromServer(0, false, drpDownProjectSelectedVal);
    }
  }, [events]);

  useEffect(() => {
    if (drpDownProjectSelectedVal) {
      UsersFromServer(0, false, drpDownProjectSelectedVal);
    }
    // setDrpDownStatusSelectedVal("ALL");
  }, [drpDownProjectSelectedVal]);

  useEffect(() => {
    UsersFromServer(0, false, drpDownProjectSelectedVal);
  }, [drpDownStatusSelectedVal]);

  const getTokenName = (i, num) => {
    const tokenNamesArray =
      userData[selectedRowId]?.TokenTypes[i][
        Object.keys(userData[selectedRowId]?.TokenTypes[i])
      ];
    const allTokenNames =
      tokenNamesArray.length > 0 &&
      (num
        ? Object.keys(tokenNamesArray[num]).toString()
        : Object.keys(tokenNamesArray[0]).toString());
    const tokenName = tokenNamesArray.length > 0 ? allTokenNames : "-";

    return tokenName;
  };

  const handleEventChange = (e) => {
    if (!e) {
      // setDrpDownProjectSelectedVal(null);

      // setSelectedEvent(null);
    } else {
      const eventName = e === "All"? e: e?.label
      setDrpDownProjectSelectedVal(eventName);
      UsersFromServer(0, false, eventName);
      navigate(
        window.location.pathname +
          `?eventName=${eventName}?startDate=${
            window.location.search.split("?")[2].split("=")[1] !==
            null
              ? window.location.search.split("?")[2].split("=")[1]
              : 0
          }?endDate=${
            window.location.search.split("?")[3].split("=")[1] !==
            null
              ? window.location.search.split("?")[3].split("=")[1]
              : 0
          }?launches=${"All"}`
      );
    }

    
  };

  const handleLaunchesChange = (e) => {
    if (!e) {
      // setDrpDownStatusSelectedVal(null);

      // setSelectedEvent(null);
    } else {
      const eventName = e === "All"? e : e

      setDrpDownStatusSelectedVal(eventName);
      navigate(
        window.location.pathname +
          `?eventName=${drpDownProjectSelectedVal}?startDate=${
            url.split("?")[2].split("=")[1] !== null
              ? url.split("?")[2].split("=")[1]
              : 0
          }?endDate=${
            url.split("?")[3].split("=")[1] !== null
              ? url.split("?")[3].split("=")[1]
              : 0
          }?launches=${eventName}`
      );
    }

   
   
  };

  return (
    <Box className={cssClasses.Container}>
      <Box mb={1}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>Token Payment Status</Box>
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box margin={"1rem 0"}></Box>

      <div className={cssClasses.filtersDiv}>
        <div className={cssClasses.filtersDivA}>
          <div style={{
                     
                      width: "300px",
                      borderRadius: "0.5rem 0.5rem",
                    }} >

            <p className={cssClasses.filterTitle}>Events: </p>
             <CustomAutoComplete
                    NoOptionsText={"No event found"}
                    InitialValue={(e) => {
                      handleEventChange(e);
                      setDrpDownStatusSelectedVal("All")

                    }}
                    
                    list={eventList}
                    multiple={false}
                    disable={false}
                    value={drpDownProjectSelectedVal}
                    placeholder="Select Event"

                  />
          </div>
          <div style={{
                     
                     width: "250px",
                     borderRadius: "0.5rem 0.5rem",
                   }} >
          <p className={cssClasses.filterTitle}>Launches: </p>
             <CustomAutoComplete
                    NoOptionsText={"No launches found"}
                    InitialValue={(e) => {
                      handleLaunchesChange(e);
                    }}
                    
                    list={["All", ...launchesName]}
                    multiple={false}
                    disable={false}
                    value={drpDownStatusSelectedVal}
                  placeholder='Select Launches'
                   
                  />
          
          </div>
        </div>
      </div>

      <Box sx={{ margin: 1 }} className={cssClasses.tableDiv}>
        <Table
          size="large"
          aria-label="purchases"
          className={cssClasses.tableBorder}
        >
          <TableHead className={cssClasses.tableHead}>
            <TableRow className={cssClasses.tableRow1}>
              <TableCell className={cssClasses.innerTitle}>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "400px" }}>Launches Name</div>
                  <div style={{ width: "200px" }}>Token Type </div>
                  <div style={{ width: "300px" }}>Token Name </div>
                  <div style={{ width: "100px" }}>Count </div>
                  <div style={{ width: "200px" }}>View </div>
                  <div style={{ width: "10px" }}>{""}</div>
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>

          <div
            className={
              paymentStatus.length > 0
                ? cssClasses.tableBodyDiv
                : cssClasses.tableBodyDivNoData
            }
          >
            <TableBody
              className={cssClasses.tableBody}
              sx={{
                maxHeight: "200px",
                overflowX: paymentStatus.length > 0 ? "scroll" : "",
              }}
            >
              {paymentStatus.length > 0 ? (
                paymentStatus.map((elm, index) => (
                  <TableRow key={index}>
                    <Accordion
                      sx={{
                        "& .MuiPaper-root": {
                          color: "darkslategray",
                          backgroundColor: "#E4FAF4",
                          borderRadius: "0.6rem",
                          boxShadow: "none",
                        },

                        boxShadow: "none",
                        borderBottom: "3px solid #EAECF0",
                      }}
                      expanded={selectedRowId === elm.id}
                    >
                      <AccordionSummary
                        expandIcon={
                          selectedRowId === elm.id ? (
                            <RemoveCircleOutlineIcon
                              sx={{
                                color: "#1570EF",
                                height: "20px",
                                width: "20px",
                              }}
                              onClick={() => setSelectedRowId(-1)}
                            />
                          ) : (
                            <AddCircleOutlineIcon
                              sx={{
                                color: "#1570EF",
                                height: "20px",
                                width: "20px",
                              }}
                              onClick={() => setSelectedRowId(elm.id)}
                            />
                          )
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",

                            width: "100%",
                            marginLeft: "0.4rem",
                          }}
                        >
                          <div
                            className={cssClasses.FirstTitle}
                            style={{ width: "400px" }}
                          >
                            {elm?.name || "-"}
                          </div>
                          <div
                            className={cssClasses.FirstTitle}
                            style={{ width: "200px" }}
                          >
                            {elm?.status || "-"}
                          </div>
                          <div
                            className={cssClasses.innerTitle}
                            style={{ width: "300px" }}
                          >
                            {elm?.tokenName}
                          </div>
                          <div
                            className={cssClasses.innerTitle}
                            style={{ width: "100px" }}
                          >
                            {elm?.count || "-"}
                          </div>
                          <div
                            className={cssClasses.innerTitle}
                            style={{
                              width: "220px",
                            }}
                          >
                            {elm?.viewDetails === "-" ? (
                              <p>-</p>
                            ) : (
                              <p
                                style={{
                                  cursor: "pointer",
                                  textDecorationLine: "underline",
                                }}
                                onClick={() => {
                                  if (elm?.viewDetails !== "-") {
                                    setViewMorePaymentStatusData(
                                      elm.viewDetails
                                    );
                                    handleMorePaymentStatusDetailsOpen();
                                    setViewDetailsPopup(elm?.tokenName);
                                  }
                                }}
                              >
                                View Details
                              </p>
                            )}
                          </div>
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: "0 !important" }}>
                        {selectedRowId !== -1 && (
                          <>
                            {userData[selectedRowId]?.TokenTypes[0][
                              "Pre-Select"
                            ].length > 1 &&
                              userData[selectedRowId]?.TokenTypes[0][
                                "Pre-Select"
                              ]?.map((el, i) => {
                                return (
                                  i !== 0 && (
                                    <div>
                                      <Divider />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          // justifyContent: "space-between",
                                          width: "100%",
                                          margin: "3rem 2rem",
                                        }}
                                      >
                                        <div
                                          className={cssClasses.FirstTitle}
                                          style={{ width: "400px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "300px" }}
                                        >
                                          {getTokenName(0, i)}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "100px" }}
                                        >
                                          {getTokenName(0, i) !== "-" &&
                                          el[getTokenName(0, i)].length > 0
                                            ? el[getTokenName(0, i)]?.length
                                            : "-"}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        >
                                          {el[Object.keys(el).toString()]
                                            ?.length > 0 ? (
                                            <p
                                              style={{
                                                cursor: "pointer",
                                                textDecorationLine: "underline",
                                              }}
                                              onClick={() => {
                                                if (
                                                  el[Object.keys(el).toString()]
                                                    ?.length > 0
                                                ) {
                                                  setViewMorePaymentStatusData(
                                                    el[
                                                      Object.keys(el).toString()
                                                    ]
                                                  );
                                                  handleMorePaymentStatusDetailsOpen();
                                                  setViewDetailsPopup(
                                                    getTokenName(0, i)
                                                  );
                                                }
                                              }}
                                            >
                                              View Details
                                            </p>
                                          ) : (
                                            <p>-</p>
                                          )}
                                        </div>
                                      </Box>
                                    </div>
                                  )
                                );
                              })}
                            <Divider />
                            {
                              <div>
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",

                                    width: "100%",
                                    margin: "2rem 0rem",
                                    marginLeft: "2rem",
                                  }}
                                >
                                  <div
                                    className={cssClasses.FirstTitle}
                                    style={{ width: "400px" }}
                                  ></div>
                                  <div
                                    className={cssClasses.FirstTitle}
                                    style={{ width: "200px" }}
                                  >
                                    {Object.keys(
                                      userData[selectedRowId]?.TokenTypes[1]
                                    ).toString()}
                                  </div>
                                  <div
                                    className={cssClasses.innerTitle}
                                    style={{ width: "300px" }}
                                  >
                                    {getTokenName(1)}
                                  </div>
                                  <div
                                    className={cssClasses.innerTitle}
                                    style={{ width: "100px" }}
                                  >
                                    {getTokenName(1) !== "-"
                                      ? userData[selectedRowId]?.TokenTypes[1][
                                          "Priority Pass"
                                        ][0][getTokenName(1)]?.length
                                      : "-"}
                                  </div>
                                  <div
                                    className={cssClasses.innerTitle}
                                    style={{ width: "200px" }}
                                  >
                                    {getTokenName(1) !== "-" ? (
                                      userData[selectedRowId]?.TokenTypes[1][
                                        "Priority Pass"
                                      ][0][getTokenName(1)]?.length === 0 ||
                                      userData[selectedRowId]?.TokenTypes[1][
                                        "Priority Pass"
                                      ][0][getTokenName(1)]?.length === "0" ? (
                                        <p>-</p>
                                      ) : (
                                        <p
                                          style={{
                                            cursor: "pointer",
                                            textDecorationLine: "underline",
                                          }}
                                          onClick={() => {
                                            if (
                                              userData[selectedRowId]
                                                ?.TokenTypes[1][
                                                "Priority Pass"
                                              ][0][getTokenName(1)]?.length > 0
                                            ) {
                                              setViewMorePaymentStatusData(
                                                userData[selectedRowId]
                                                  ?.TokenTypes[1][
                                                  "Priority Pass"
                                                ][0][getTokenName(1)]
                                              );
                                              handleMorePaymentStatusDetailsOpen();
                                              setViewDetailsPopup(
                                                getTokenName(1)
                                              );
                                            }
                                          }}
                                        >
                                          View Details
                                        </p>
                                      )
                                    ) : (
                                      <p>-</p>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            }
                            {userData[selectedRowId]?.TokenTypes[1][
                              "Priority Pass"
                            ].length > 1 &&
                              userData[selectedRowId]?.TokenTypes[1][
                                "Priority Pass"
                              ]?.map((el, i) => {
                                return (
                                  i !== 0 && (
                                    <div>
                                      <Divider />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                          margin: "2rem 0rem",
                                          marginLeft: "2rem",
                                        }}
                                      >
                                        <div
                                          className={cssClasses.FirstTitle}
                                          style={{ width: "400px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "300px" }}
                                        >
                                          {getTokenName(1, i)}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "100px" }}
                                        >
                                          {getTokenName(1, i) !== "-" &&
                                          el[getTokenName(1, i)].length > 0
                                            ? el[getTokenName(1, i)]?.length
                                            : "-"}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        >
                                          {el[Object.keys(el).toString()]
                                            ?.length > 0 ? (
                                            <p
                                              style={{
                                                cursor: "pointer",
                                                textDecorationLine: "underline",
                                              }}
                                              onClick={() => {
                                                if (
                                                  el[Object.keys(el).toString()]
                                                    ?.length > 0
                                                ) {
                                                  setViewMorePaymentStatusData(
                                                    el[
                                                      Object.keys(el).toString()
                                                    ]
                                                  );
                                                  handleMorePaymentStatusDetailsOpen();
                                                  setViewDetailsPopup(
                                                    Object.keys(el).toString()
                                                  );
                                                }
                                              }}
                                            >
                                              View Details
                                            </p>
                                          ) : (
                                            <p>-</p>
                                          )}
                                        </div>
                                      </Box>
                                    </div>
                                  )
                                );
                              })}
                            <Divider />
                            {
                              <div>
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",

                                    width: "100%",
                                    margin: "2rem 0rem",
                                    marginLeft: "2rem",
                                  }}
                                >
                                  <div
                                    className={cssClasses.FirstTitle}
                                    style={{ width: "400px" }}
                                  ></div>
                                  <div
                                    className={cssClasses.FirstTitle}
                                    style={{ width: "200px" }}
                                  >
                                    {Object.keys(
                                      userData[selectedRowId]?.TokenTypes[2]
                                    ).toString()}
                                  </div>
                                  <div
                                    className={cssClasses.innerTitle}
                                    style={{ width: "300px" }}
                                  >
                                    {getTokenName(2)}
                                  </div>
                                  <div
                                    className={cssClasses.innerTitle}
                                    style={{ width: "100px" }}
                                  >
                                    {getTokenName(2) !== "-"
                                      ? userData[selectedRowId]?.TokenTypes[2][
                                          "Global Token"
                                        ][0][getTokenName(2)]?.length
                                      : "-"}
                                  </div>
                                  <div
                                    className={cssClasses.innerTitle}
                                    style={{ width: "200px" }}
                                  >
                                    {getTokenName(2) !== "-" ? (
                                      userData[selectedRowId]?.TokenTypes[2][
                                        "Global Token"
                                      ][0][getTokenName(2)]?.length === 0 ||
                                      userData[selectedRowId]?.TokenTypes[2][
                                        "Global Token"
                                      ][0][getTokenName(2)]?.length === "0" ? (
                                        <p>-</p>
                                      ) : (
                                        <p
                                          style={{
                                            cursor: "pointer",
                                            textDecorationLine: "underline",
                                          }}
                                          onClick={() => {
                                            if (
                                              userData[selectedRowId]
                                                ?.TokenTypes[2][
                                                "Global Token"
                                              ][0][getTokenName(2)]?.length > 0
                                            ) {
                                              setViewMorePaymentStatusData(
                                                userData[selectedRowId]
                                                  ?.TokenTypes[2][
                                                  "Global Token"
                                                ][0][getTokenName(2)]
                                              );
                                              handleMorePaymentStatusDetailsOpen();
                                              setViewDetailsPopup(
                                                getTokenName(2)
                                              );
                                            }
                                          }}
                                        >
                                          View Details
                                        </p>
                                      )
                                    ) : (
                                      <p>-</p>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            }
                            {userData[selectedRowId]?.TokenTypes[2][
                              "Global Token"
                            ].length > 1 &&
                              userData[selectedRowId]?.TokenTypes[2][
                                "Global Token"
                              ]?.map((el, i) => {
                                return (
                                  i !== 0 && (
                                    <div>
                                      <Divider />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                          margin: "2rem 0rem",
                                          marginLeft: "2rem",
                                        }}
                                      >
                                        <div
                                          className={cssClasses.FirstTitle}
                                          style={{ width: "400px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "300px" }}
                                        >
                                          {getTokenName(2, i)}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "100px" }}
                                        >
                                          {getTokenName(2, i) !== "-" &&
                                          el[getTokenName(2, i)].length > 0
                                            ? el[getTokenName(2, i)]?.length
                                            : "-"}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        >
                                          {el[Object.keys(el).toString()]
                                            ?.length > 0 ? (
                                            <p
                                              style={{
                                                cursor: "pointer",
                                                textDecorationLine: "underline",
                                              }}
                                              onClick={() => {
                                                if (
                                                  el[Object.keys(el).toString()]
                                                    ?.length > 0
                                                ) {
                                                  setViewMorePaymentStatusData(
                                                    el[
                                                      Object.keys(el).toString()
                                                    ]
                                                  );
                                                  handleMorePaymentStatusDetailsOpen();
                                                  setViewDetailsPopup(
                                                    Object.keys(el).toString()
                                                  );
                                                }
                                              }}
                                            >
                                              {" "}
                                              View Details
                                            </p>
                                          ) : (
                                            <p>-</p>
                                          )}
                                        </div>
                                      </Box>
                                    </div>
                                  )
                                );
                              })}
                          </>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </TableRow>
                ))
              ) : (
                <div className={cssClasses.noDataWrapper}>
                  <div className={cssClasses.noDataMsg}>
                    <div className={cssClasses.emptyIcon}>
                      <img src={EmptyListIcon} alt="No Requests" />
                    </div>
                    <div className={cssClasses.emptyTitle}>
                      No Token payment status to show!
                    </div>
                  </div>
                </div>
              )}
            </TableBody>
          </div>
        </Table>
      </Box>

      {openMorePaymentStatusDetails && (
        <TokenPaymentStatusDetailsModal
          open={openMorePaymentStatusDetails}
          handleClose={handleMorePaymentStatusDetailsClose}
          data={ViewMorePaymentStatusData}
          popupType={viewDetailsPopup}
        />
      )}
    </Box>
  );
}

export default TokenPaymentStatus;
